module.exports = getBufferResponse

function getBufferResponse (response) {
  return response.buffer()
}
